import { ICountryInfo } from "../country";

export interface Phone extends ICountryInfo {
    contactTypeId: number;
    extn?: string;
    isDirectory: boolean;
    isPrimary: boolean;
    number: string;
    typeId: number;
}

export class PhoneHelper {
    public static displayFormatted(p?: Phone) {
        if (p === undefined || p === null || !p.number)
            return "";

        if (p.countryCode === "US") {
            const n = p.number.replace(/\D/g, "");
            if (n.length === 10)
                return `(${n.substr(0, 3)}) ${n.substr(3, 3)}-${n.substr(6)}`;
            return p.number;
        }
        else {
            const n = p.number.replace(/^0+/g, ""); // remove leading zero
            return `+${p.countryPhoneCode} ${n}`; // prefix with country code
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/contact/Phone.ts